import type { ReactNode } from 'react'
import { RfidAppHeader } from '@/components/rfid/RfidAppHeader'
import { RegionSwitcher } from '@/components/common/RegionSwitcher'

type Props = {
  title: string
  subtitle?: string
  actions?: ReactNode
}

/** Red app chrome header (RFID_RE_FE parity) with region switcher. */
export function PageHeader({ title, subtitle, actions }: Props) {
  return (
    <RfidAppHeader
      title={title}
      subtitle={subtitle}
      right={
        <div className="flex max-w-full flex-wrap items-center justify-end gap-2">
          <RegionSwitcher className="rfid-header-region" />
          {actions}
        </div>
      }
    />
  )
}

PageHeader.isPageHeader = true as const
